import React, { Component, useEffect, useState } from 'react';
//import logo from './logo.svg';
import './App.css';
// import '../Services/Forecast/ForecastByMunicipalities/ForecastByMunicipalities.css';

import Nav from '../Nav/NavWithHooks';
import Footer from '../Footer/Footer';
import Emas from '../Services/Emas/Emas';
import Home from '../Home';
import Images from '../Services/Weather/Images/Images';
//import Services from '../Services/Services';

import { Route, Switch, HashRouter, Redirect } from 'react-router-dom';

import en from '../../language/en/App.json';
import es from '../../language/es/App.json';
import AllServices from '../Services/Services';
import Workers from '../CMP/Workers/Workers';
import Worker from '../CMP/Worker/Worker';
import Project from '../Investigation/Project/Project';
import Projects from '../Investigation/Projects/Projects';
import WeatherCard from '../WeatherCard/WeatherCard';
import PrimarySearchAppBar from '../NotFound/NotFound';

import News from '../CMP/News/News';
import New from '../CMP/New/New';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { withRouter } from 'react-router-dom';
import Stations from '../Services/Weather/Stations/Stations';
import Events from '../Investigation/Events/Eventos';
import Slider from '../Home/Slider/Slider-ui';
import Contact from '../CMP/Contact/Contact';
import Cmp from '../CMP';

import 'fontsource-roboto';
import { Fab, Zoom, useScrollTrigger } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import WorkingOn from '../WorkingOn/WorkingOn';
import ApiDoc from '../Api/ApiDoc';
import Hurricanes from '../Services/Hurricanes/Hurricanes';
import Alerts from '../Services/Alerts/Alerts';
import Bulletin from '../Services/Bulletin/Bulletin';
import Forecast from '../Services/Forecast/Forecast';
import Pvr from '../Services/Pvr/Pvr';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {
        lang: {
          en: en,
          es: es
        }
      },
      forecastIn: true,
      selectedLanguage: 'es'
    };
    //console.log(es);
    // document.body.onload = e => {
    //   //e.preventDefault();
    //   console.log('coordenadas','(', e.pageX, '; ', e.pageY, ')');
    //   console.log('window information: ', window.scrollY);

    //   let y = e.pageY;
    //   const interval = setInterval(() => {
    //     y -= 100;
    //     window.scrollTo(0, y);
    //     console.log('scroll: ', y);
    //   }, 10);

    //   setTimeout(() => clearInterval(interval), 2000);
    // };
  }

  handleForecastSection(b, s) {
    setTimeout(() => this.setState({
      forecastIn: b
    }), s * 1000);

    //alert('me llamaron?');
  }

  render() {
    const SolicitarServicio = () => (
      <div className="container" style={{ marginTop: 100 }}>
        <div class="heading">
          <h2><strong>Solicitar Servicio</strong></h2>
        </div>
      </div>
    )

    const AnimatedSwitch = withRouter(({ location }) => {
      return (
        <TransitionGroup>
          <CSSTransition key={location.pathname} classNames="slide" timeout={1000}>
            <Switch location={location}>
              <Route path="/cmp/worker/:id" component={() => <Worker lang={this.state.selectedLanguage} />} />
              <Route path="/cmp/workers" component={() => <Workers lang={this.state.selectedLanguage} />} />
              <Route path="/cmp/all" component={() => <Cmp lang={this.state.selectedLanguage} />} />
              {/* <Route path="/cmp/history" component={() => <History lang={this.state.selectedLanguage} parent={true} />} />
              <Route path="/cmp/mission" component={() => <Mission lang={this.state.selectedLanguage} parent={true} />} />
              <Route path="/cmp/structure" component={() => <Structure lang={this.state.selectedLanguage} />} />
              <Route path="/cmp/clients" component={() => <Clients lang={this.state.selectedLanguage} />} /> */}
              <Route path="/new/:slug" component={() => <New lang={this.state.selectedLanguage} />} />
              <Route path="/news/category/:category" component={() => <News lang={this.state.selectedLanguage} />} />
              <Route path="/news" component={() => <News lang={this.state.selectedLanguage} />} />
              <Route path="/cmp/contact" component={() => <Contact lang={this.state.selectedLanguage} />} />
              <Route path="/cmp/sitemap" component={() => <WorkingOn />} />
              <Route path="/service/solicitar" component={() => <SolicitarServicio />} />
              <Route path="/service/weather/stations/emas" component={() => <Emas lang={this.state.selectedLanguage} />} />
              <Route path="/service/weather/stations" component={() => <Stations lang={this.state.selectedLanguage} />} />
              <Route path="/service/weather-forecast" component={() => <Forecast lang={this.state.selectedLanguage} />} />
              {/* <Route path="/service/forecast" component={() => <ForecastByMunicipalities lang={this.state.selectedLanguage} in={this.handleForecastSection.bind(this)} />} /> */}
              {/* <Route path="/service/gforecast" component={() => <ExtendedForecast lang={this.state.selectedLanguage} />} /> */}
              <Route path="/service/clime" component={() => <Bulletin />} />
              <Route path="/service/bulletin" component={() => <Bulletin />} />
              <Route path="/service/air" component={() => <WorkingOn />} />
              <Route path="/service/hurricanes" component={() => <Hurricanes />} />
              <Route path="/service/alert" component={() => <Alerts />} />
              {/* <Route path="/service/:id" component={() => <WorkingOn />} />  () => <Service lang={this.state.selectedLanguage} />, esto es lo que estaba */}
              <Route path="/product/weather/images" component={() => <Images lang={this.state.selectedLanguage} />} />
              <Route path="/services/all" component={() => <AllServices lang={this.state.selectedLanguage} />} />
              <Route path="/service/pvr" component={() => <Pvr lang={this.state.selectedLanguage} />} />
              <Route path="/investigation/project/:id" component={() => <Project lang={this.state.selectedLanguage} />} />
              <Route path="/investigation/projects" component={() => <Projects lang={this.state.selectedLanguage} />} />
              <Route path="/investigation/events" component={() => <Events lang={this.state.selectedLanguage} />} />
              <Route path="/investigation/cta" component={() => <WorkingOn />} />
              <Route path="/investigation/publications" component={() => <WorkingOn />} />
              <Route path="/download/apk" component={() => <h1 className="efecto-espejo" lang={this.state.selectedLanguage} >Descargar APK</h1>} />
              <Route path="/404" component={() => <PrimarySearchAppBar lang={this.state.selectedLanguage} />} />
              <Route path="/home" component={() => <Home lang={this.state.selectedLanguage} />} />
              <Route path="/api/doc" component={() => <ApiDoc lang={this.state.selectedLanguage} />} />
              <Redirect from='/' to='/home' />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      )
    });

    const SliderShow = withRouter(({ location }) => {
      return (
        <React.Fragment>
          {(location.pathname === '/home') && <Slider lang={this.state.selectedLanguage} />}
        </React.Fragment>
      )
    });

    const NavWithSlide = withRouter(({ location }) => {
      const [sliderShow, setSliderShow] = useState(location.pathname === '/home');
      // console.log('location.pathname', location.pathname);
      useEffect(() => {
        setSliderShow(location.pathname === '/home')
      }, [location.pathname])
      // console.log('sliderShow', sliderShow)
      return (
        <Nav onChange={(lang) => this.setState({ selectedLanguage: lang })} sliderShow={sliderShow} />
      )
    });
    console.log('in render', this.state.selectedLanguage)
    return (
      <React.Fragment>
        <HashRouter>
          <SliderShow />
          <Nav onChange={(lang) => this.setState({ selectedLanguage: lang })} />
          <WeatherCard lang={this.state.selectedLanguage} />
          <AnimatedSwitch />
          <Footer lang={this.state.selectedLanguage} />
        </HashRouter >

        {/* <a href="#root" className="go2top">
          <i className="fa fa-arrow-up"></i>
        </a> */}
{/* <a href="#root" className="go2top"> */}
        <ScrollTop {...this.props}>
          <Fab color="secondary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
        {/* </a> */}
      </React.Fragment>
    )
  }
}

// Para el scroll suavizado hasta la parte superior
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#root');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default App;